import { z } from 'zod';

export const clientDetailsSchema = z.object({
  clientName: z.string().min(1, 'Client Name is required').max(100, 'Max 100 characters'),
  primaryContactEmail: z.string().email('Invalid email').or(z.literal('')),
  logo: z.string().url('Invalid URL').or(z.literal('')),
  billingCurrency: z.string(),
  hasMatchmakingAccess: z.boolean(),
  enableConneqtAccess: z.boolean(),
  isIsolatedInstance: z.boolean(),
  enableProcurementModule: z.boolean(),
  enableBiddingModule: z.boolean(),
  isDemo: z.boolean(),
  limits: z.object({
    numUsers: z.number().min(0, 'Must be at least 0'),
    numTeams: z.number().min(0, 'Must be at least 0'),
  }),
  subscriptionStatus: z.string(),
  managedBy: z.string(),
  currentPeriodEnd: z.string().or(z.literal('')),
});

export type ClientDetailsFormData = z.infer<typeof clientDetailsSchema>;
